import { useQuery } from '@tanstack/react-query';
import { connectApi } from '../services/api';

/**
 * Hook to fetch live queue metrics from AWS Connect
 *
 * @param {string} instanceId - AWS Connect instance ID
 * @param {string[]} queueIds - Array of queue IDs to fetch metrics for
 * @param {string} region - AWS region (default: us-east-1)
 * @param {object} options - Additional options
 * @param {number} options.refetchInterval - Refetch interval in ms (default: 15000)
 * @param {boolean} options.enabled - Whether to enable the query (default: true)
 */
export const useLiveQueueMetrics = (
  instanceId,
  queueIds,
  region = 'us-east-1',
  options = {}
) => {
  const { refetchInterval = 15000, enabled = true } = options;

  const isEnabled = Boolean(enabled && instanceId && queueIds && queueIds.length > 0);

  return useQuery({
    queryKey: ['liveQueueMetrics', instanceId, queueIds, region],
    queryFn: () => connectApi.getLiveQueueMetrics(instanceId, queueIds, region),
    enabled: isEnabled,
    refetchInterval: isEnabled ? refetchInterval : false,
    staleTime: 10000, // Consider data stale after 10 seconds
    refetchOnWindowFocus: true,
  });
};

export default useLiveQueueMetrics;
